/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createPlaidSandboxPublicToken} from '../api'

export const useMutationCreatePlaidSandboxPublicToken = createReactQueryMutationHook('createPlaidSandboxPublicToken', createPlaidSandboxPublicToken)
